export default __webpack_public_path__ + "static/media/952.e3f93f87.png";